import React, { useEffect, useState } from "react"
import styled, { keyframes, css } from "styled-components"

const getMobilePlatform = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera
  if (/android/i.test(ua)) return "android"
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios"
  return "web"
}

const MobilePushNotification = ({
  title,
  message,
  icon,
  onClose,
  duration = 5000,
}) => {
  const [platform, setPlatform] = useState("web")

  useEffect(() => {
    setPlatform(getMobilePlatform())
    const timer = setTimeout(onClose, duration)
    return () => clearTimeout(timer)
  }, [onClose, duration])

  return (
    <NotificationContainer platform={platform}>
      {icon && <Icon src={icon} alt="icon" />}
      <TextWrapper>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </TextWrapper>
    </NotificationContainer>
  )
}

export default MobilePushNotification

/* === Styled Components === */

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
`

const NotificationContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 400px;
  border-radius: 14px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
  z-index: 9999;
  animation: ${slideDown} 0.4s ease-out;
  transition: opacity 0.3s ease;

  ${({ platform }) =>
    platform === "android" &&
    css`
      background-color: #2c2c2c;
      color: #fff;
    `}

  ${({ platform }) =>
    platform === "ios" &&
    css`
      background-color: #ffffff;
      color: #000;
      border: 1px solid #e0e0e0;
    `}

  ${({ platform }) =>
    platform === "web" &&
    css`
      background-color: #444;
      color: #fff;
    `}
`

const Icon = styled.img`
  width: 48px;
  height: 48px;
  margin-right: 12px;
  border-radius: 10px;
  object-fit: contain;
  flex-shrink: 0;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 2px;
`

const Message = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors?.grayText || "#d1d1d6"};
`